import { render, staticRenderFns } from "./FileInputFormatter.vue?vue&type=template&id=66a6e23e&"
import script from "./FileInputFormatter.vue?vue&type=script&lang=js&"
export * from "./FileInputFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports